import { ChannelListItem } from '../ChannelListItem';
import React from 'react';
import type { Channel, AddressType } from 'application-types';
import type { Edge as BuildingEdge } from 'lane-shared/contexts/SignUpContext/useOnboardingBuildings';
import { useWorkplaceOnboardingEnabled } from 'lane-shared/hooks/onboarding/useWorkplaceOnboardingEnabled';
import { useFlag } from 'lane-shared/hooks';
import { FeatureFlag } from 'constants-flags';



type ChannelListItemWrapperProps = {
  building: BuildingEdge;
  className?: string;
  style?: React.CSSProperties;
  onClick: (channel: Channel) => void;
  showName?: boolean;
  isSelected?: boolean;
};

export function ChannelListItemWrapper({
  building,
  className,
  style,
  onClick,
  isSelected,
}: ChannelListItemWrapperProps) {
  const isWorkplaceOnboardingEnabled = useWorkplaceOnboardingEnabled();
  const isMergeBuildingAndCompanyEnabled = useFlag(
    FeatureFlag.OnboardingMergeBuildingAndCompany,
    false
  );
  const channel = convertBuildingEdgeToChannelType(building);

  return (
    <ChannelListItem
      className={className}
      style={style}
      showName
      channel={channel}
      onClick={onClick}
      showCompanyIcon={isWorkplaceOnboardingEnabled || isMergeBuildingAndCompanyEnabled}
      isSelected={(isWorkplaceOnboardingEnabled || isMergeBuildingAndCompanyEnabled) && isSelected}
    />
  );
}

export function convertBuildingEdgeToChannelType(building: BuildingEdge): Channel {
  return {
    _id: building.node.id,
    profile: {
      name: building.node.name,
      logo: building.node.thumbnailUrl,
    },
    address: building.node.address,
    inviteOnly: building.node.inviteOnly,
  } as Channel;
}

export function convertChannelToBuildingEdge(channel: Channel): BuildingEdge {
  
  const defaultAddress: AddressType = {
    _id: '',
    _created: new Date(),
    _updated: new Date(),
    _createdBy: '',
    _updatedBy: '',
    name: '',
    street1: '',
    street2: null,
    street3: null,
    city: '',
    state: '',
    code: '',
    country: '',
    geo: [0, 0],
  };
  const address = channel.address ?? defaultAddress;

  return {
    cursor: channel._id,
    node: {
      id: channel._id,
      name: channel.profile?.name || '',
      thumbnailUrl: channel.profile?.logo || null,
      inviteOnly: channel.inviteOnly || false,
      address,
      matchesEmailDomain: false,
    },
  };
}
